module.exports = __webpack_public_path__ + "img/serres-toundra.4ab1213c.png";